<template>
  <div class="navbar">
    <div class="left-menu">
      {{ this.$route.meta.title }}
    </div>
    <div class="right-menu">
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-caret-bottom" />
          <span>{{ userName }}({{ userId }})</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/index/index" v-if="$store.getters.roleId !== 10">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="changePs" style="display:block;">修改密码</span>
          </el-dropdown-item>
          <router-link to="/index/DownloadCenter">
            <el-dropdown-item divided>下载中心</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided v-if="canRevent" @click.native="reventDialogVisible = true">
            <span style="display:block;">恢复交易</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">登出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 通知按钮 -->
    <div class="notice-button" :class="!noticeHasViewed && 'twinkling-animation'" @click="noticeButtonClick">
      <img src="../../../static/images/notice-icon.png">
    </div>
    <!-- 静态条码的风险及防范dialog -->
    <qr-warning-dialog :visible.sync="qrWarningDialogVisible"></qr-warning-dialog>
    <!-- 密码修改dialog -->
    <el-dialog title="密码修改" :visible.sync="dialogFormVisible" :append-to-body="true" @close="$emit('update:visible', dialogFormVisible)">
      <el-row>
        <el-form :model="formList" label-width="80px" label-position="left" ref="ruleForm" :rules="ruleData">
          <el-form-item
            class="edit-form"
            label="当前密码"
            prop="oldPassword">
            <el-input
              type="password"
              placeholder="当前密码"
              auto-complete="off"
              style="width: 50%"
              v-model="formList.oldPassword"></el-input>
          </el-form-item>
          <el-form-item
            class="edit-form"
            label="新密码"
            prop="newPassword">
            <el-input
              type="password"
              placeholder="新密码"
              auto-complete="off"
              style="width: 50%"
              v-model="formList.newPassword"></el-input>
          </el-form-item>
          <el-form-item
            class="edit-form"
            label="确认密码"
            prop="ensureNewPassword">
            <el-input
              type="password"
              placeholder="确认密码"
              auto-complete="off"
              style="width: 50%"
              v-model="formList.ensureNewPassword"></el-input>
          </el-form-item>
          <el-form-item prop="verifyCode" label="验证码" class="edit-form">
            <div class="edit-code-form">
              <el-input
                placeholder="验证码"
                style="width: 20%"
                v-model="formList.verifyCode">
              </el-input>
              <div class="view-account__item-cn">
                <img
                  :src="verifyCode"
                  class="verify"
                  width="110"
                  height="40"
                  style="float: left;background-color: rgb(209, 209, 209)"
                  @click="getVerifyCode()"
                >
                <i
                  @click="getVerifyCode()"
                  style="cursor:pointer;display:inline-block;font-size: 30px;margin-left: 20px"
                  class="el-icon-refresh-left"></i>
              </div>
            </div>

          </el-form-item>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer" style="width:100%">
        <el-button @click="dialogFormVisible = false">取 消
        </el-button>
        <el-button icon="el-icon-edit" type="primary" @click="editSubmit" :loading="addLoading">修改
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="恢复交易"
      v-if="reventDialogVisible"
      :visible.sync="reventDialogVisible"
      width="810px"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closeReventDialog">
      <iframe :src="h5Link" frameborder="0" style="height: 750px;width: 780px;"></iframe>
      <div style="text-align: center">
        <el-button style="width: 100px" @click="closeReventDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qrWarningDialog from '@/components/QRWarningDialog/qrWarningDialog'
import { logout } from '@/api/user'
import { validCode, changeMerchantPs, changePs } from '@/api/global'
import md5 from 'js-md5'
import qs from 'qs'
import { validStrictPsd, strictPsdError, validSimplePsd, simplePsdError } from '@/utils/validate'
import { checkMerchantTransStatus } from '@/api/merchant'

export default {
  name: 'Navbar',
  components: {
    qrWarningDialog
  },
  data () {
    return {
      userName: '',
      userId: '',
      formList: {
        oldPassword: '',
        newPassword: '',
        ensureNewPassword: '',
        verifyCode: ''
      },
      currentPage3: 1,
      verifyCode: '',
      tableData: [],
      addLoading: false,
      dialogFormVisible: false,
      accountVisible: false,
      qrWarningDialogVisible: false,
      noticeHasViewed: localStorage.getItem('QR_WARING_HAS_VIEWED') === 'true',
      ruleData: {
        oldPassword: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入当前密码'))
            } else {
              return callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        newPassword: [{
          validator: (rule, value, callback) => {
            if (this.isAgent) {
              if (validStrictPsd(value)) {
                callback()
              } else {
                return callback(new Error(strictPsdError))
              }
            } else {
              if (validSimplePsd(value)) {
                callback()
              } else {
                return callback(new Error(simplePsdError))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        ensureNewPassword: [{
          validator: (rule, value, callback) => {
            if (this.isAgent) {
              if (!value) {
                callback(new Error('请输入8-20位大写/小写字母/数字/符号中的至少三种组合'))
              } else if (value !== this.formList.newPassword) {
                callback(new Error('两次输入的新密码不一致!'))
              } else if (!validStrictPsd(value)) {
                callback(new Error(strictPsdError))
              } else {
                callback()
              }
            } else {
              if (!value) {
                callback(new Error(simplePsdError))
              } else if (value !== this.formList.newPassword) {
                callback(new Error('两次输入的新密码不一致!'))
              } else if (!validSimplePsd(value)) {
                callback(new Error(simplePsdError))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        verifyCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 4, message: '请输入4位验证码', trigger: 'blur' }
        ]
      },
      isAgent: this.$store.getters.roleId === 1 || this.$store.getters.roleId === 3,
      sessionId: '',
      canRevent: false,
      reventDialogVisible: false,
      h5Domain: 'https://t-h5.lepass.cn/wap/' // 请求h5域名
    }
  },
  watch: {
    dialogFormVisible () {
      if (this.dialogFormVisible) {
        this.getVerifyCode()
      }
    }
  },
  created () {
    this.userName = this.$store.getters.userName
    this.userId = this.$store.getters.userId
    this.sessionId = this.$store.state.user.sessionId
    switch (process.env.CUSTOM_ENV) {
      case 'test': {
        this.h5Domain = 'https://t-h5.lepass.cn/wap/'
        break
      }
      case 'pre': {
        this.h5Domain = 'https://p-h5.lepass.cn/wap/'
        break
      }
      case 'prd': {
        this.h5Domain = 'https://h5.leshuazf.com/wap/'
        break
      }
      default: {
        this.h5Domain = 'https://t-h5.lepass.cn/wap/'
      }
    }
    if (!this.isAgent && this.$store.getters.roleId === 2) {
      this.checkMerchantTransStatus()
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
    },
    changePs () {
      this.dialogFormVisible = true
    },
    changeAccountVisible () {
      this.accountVisible = true
    },
    noticeButtonClick () {
      if (!this.noticeHasViewed) {
        localStorage.setItem('QR_WARING_HAS_VIEWED', true)
        this.noticeHasViewed = true
      }
      this.qrWarningDialogVisible = true
    },
    editSubmitCallback (para, callback) {
      if (this.$store.getters.roleId === 2 || this.$store.getters.roleId === 4) {
        changeMerchantPs(para).then(data => callback(data))
      } else {
        changePs(para).then(data => callback(data))
      }
      this.resetFormList()
    },
    editSubmit () {
      const oldPw = this.formList.oldPassword
      const newPw = this.formList.newPassword
      const enPw = this.formList.ensureNewPassword
      const that = this
      let isValid = true
      this.$refs.ruleForm.validate((valid) => {
        isValid = valid
        return valid
      })
      if (!isValid) return
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true
        let para = Object.assign({}, this.formList)
        // para = JSON.parse(JSON.stringify(para))
        console.log(this.formList)
        if (oldPw) { para.oldPassword = md5(oldPw) }
        if (newPw) { para.newPassword = md5(newPw) }
        if (enPw) { para.ensureNewPassword = md5(enPw) }
        para = qs.stringify(para)
        that.editSubmitCallback(para, (data) => {
          that.addLoading = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            this.dialogFormVisible = false
            logout().then(data => {
              this.$router.push('/login')
            })
          } else {
            this.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            // this.dialogFormVisible = false
          }
        })
      })
    },
    logout () {
      var data = {}
      var that = this
      data = qs.stringify(data)
      that.$confirm('确定退出登录么?', '确认退出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout(data).then(data => {
          const QR_WARING_HAS_VIEWED = localStorage.getItem('QR_WARING_HAS_VIEWED')
          localStorage.setItem('QR_WARING_HAS_VIEWED', QR_WARING_HAS_VIEWED)
          that.$router.push('/login')
        })
      })
    },
    getVerifyCode () {
      let data = {}
      data = qs.stringify(data)
      validCode(data).then(data => {
        if (data.error_code) {
          this.verifyCode = data.verifyCodeUrl
        }
      })
    },
    resetFormList () {
      this.formList = {
        oldPassword: '',
        newPassword: '',
        ensureNewPassword: '',
        verifyCode: ''
      }
    },
    checkMerchantTransStatus () {
      const params = qs.stringify({
        merchantId: this.userId
      })
      checkMerchantTransStatus(params).then(res => {
        if (res.result_cde === 0) {
          if (res.data.transState === 3) {
            this.canRevent = true
          }
        }
      })
    },
    closeReventDialog () {
      this.checkMerchantTransStatus()
      this.reventDialogVisible = false
    }
  },
  computed: {
    h5Link () {
      return `${this.h5Domain}merchant-management-h5/#/?merchantId=${this.userId}&merchantUserName=${this.userName}&userName=${this.userName}&sessionId=${this.sessionId}&source=saas-register-api`
    }
  }
}
</script>

<style lang="scss" scoped>
  .block-account{
    width:240px;
    margin:0 0 20px 0;
  }
  .hr{
    margin:20px 0 0 0;
  }
  .navbar {
    width: 100%;
    height:50px;
    line-height:50px;
    background: #fff;
  }
  .left-menu {
    float:left;
    height:100%;
    font-size:14px;
    line-height:50px;
    margin-left:30px
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        font-size:14px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }
  .notice-button {
    float: right;
    margin-right: 35px;
    cursor: pointer;
    height: 50px;
    img {
      height: 30px;
      width: 30px;
      vertical-align: middle;
    }
  }
  .twinkling-animation {
    animation: twinkling 1.5s infinite ease-in-out;
  }
  @keyframes twinkling {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .view-account__item-cn{
    display: flex;
    align-items: center;
      margin-left: 20px;
  }
  .edit-code-form{
    display: flex;
    align-items: center;
      flex-direction: row;
  }
</style>
<style lang="scss">
  .v-modal {
    z-index:120!important
  }
</style>
